import type {
  InsightsCompactFilters,
  ParsedInsightsFilters,
} from '@/common/api/types/dashboard/filters';
import {
  buildInsightsStructuredSearch,
  type ParsedDateFilter,
} from '@/common/utils/compact-filters/transformCompactFilters';

const transformToDateFilter = (
  parsed: { value: string[] | null; operator: string } | undefined,
): ParsedDateFilter | undefined => {
  if (!parsed) return undefined;

  if (parsed.operator === 'null' || parsed.operator === 'notnull') {
    return {
      value: [],
      operator: parsed.operator,
    };
  }

  if (!parsed.value || parsed.value.length === 0) return undefined;

  return {
    value: parsed.value,
    operator: parsed.operator as ParsedDateFilter['operator'],
  };
};

export const transformCompactToParsedFilters = (
  filters: InsightsCompactFilters,
): ParsedInsightsFilters => {
  const structured = buildInsightsStructuredSearch(filters);

  return {
    teamId: structured.teamId?.value ?? undefined,
    statusId: structured.statusId?.value ?? undefined,
    itemTypeId: structured.itemTypeId?.value ?? undefined,
    plannedStartDateTime: transformToDateFilter(structured.plannedStartDateTime),
    plannedFinishDateTime: transformToDateFilter(structured.plannedFinishDateTime),
  };
};
